import React from 'react';

const Icons = () => {};

Icons.Instructions = function Instructions() {
  return <span className="material-symbols-rounded">help</span>;
};

Icons.Back = function Back() {
  return <span className="material-symbols-rounded">arrow_back</span>;
};

Icons.Share = function Share() {
  return <span className="material-symbols-rounded">share</span>;
};

Icons.PreviousGames = function PreviousGames() {
  return <span className="material-symbols-rounded">calendar_month</span>;
};

Icons.Backspace = function Backspace() {
  return <span className="material-symbols-rounded">backspace</span>;
};

Icons.ExternalLink = function ExternalLink() {
  return <span className="material-symbols-rounded">open_in_new</span>;
};

Icons.Unlimited = function Unlimited() {
  return <span className="material-symbols-rounded">all_inclusive</span>;
};

Icons.PlayAgain = function PlayAgain() {
  return <span className="material-symbols-rounded">replay</span>;
};

Icons.Daydash = function Daydash() {
  return (
    <svg
      viewBox="0 0 1954 478"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M1357.85 273.104C1311.23 284.963 1281.12 289.659 1259.83 274.567C1206.84 228.928 1371.81 223.635 1443.03 264.624V194.355C1391.91 173.649 1225.6 161.416 1220.17 240.307C1211.73 357.807 1386.12 289.508 1386.12 289.508C1386.12 289.508 1278.15 355.977 1220.17 305.111C1220.17 339.605 1220.17 337.325 1220.17 377.929C1273.04 385.475 1393.09 384.756 1436.41 354.213C1462.12 335.887 1471.29 243.64 1357.85 273.104Z" />
      <path d="M1839.8 155.172L1819.37 205.649L1798.83 155.299L1748.35 134.62L1798.83 114.2L1819.37 63.8493L1839.8 114.2L1890.15 134.62L1839.8 155.172ZM1936.05 107.244L1906.56 92.7333C1887.03 83.1319 1871.27 67.2959 1861.75 47.7306L1847.32 18.0666C1842.15 7.41994 1831.35 0.66394 1819.51 0.66394C1807.71 0.66394 1796.95 7.36529 1791.75 17.944L1777.01 47.8973C1767.48 67.2866 1751.79 82.9733 1732.4 92.5106L1703.13 106.903C1695.49 110.665 1689.29 117.149 1686.71 125.268C1681.8 140.593 1689.04 156.24 1702.56 162.817L1732.24 177.248C1751.8 186.764 1767.63 202.529 1777.24 222.051L1791.75 251.555C1796.95 262.133 1807.71 268.835 1819.51 268.835C1831.35 268.835 1842.15 262.079 1847.32 251.432L1861.53 222.219C1871.11 202.523 1887.03 186.611 1906.72 177.029L1935.24 163.152C1942.92 159.421 1949.13 152.957 1951.76 144.841C1956.72 129.536 1949.53 113.875 1936.05 107.244Z" />
      <path d="M111.208 320.347C86.7413 320.347 71.4466 302.432 71.4466 279.275C71.4466 256.557 86.7413 239.076 111.208 239.076C135.676 239.076 150.968 256.557 150.968 279.275C150.968 302.432 135.676 320.347 111.208 320.347ZM223.061 81.3467H129.123V140.331H150.968V190.579C136.987 180.531 119.511 174.411 98.5359 174.411C37.8053 174.411 0.665283 221.6 0.665283 279.712C0.665283 337.823 41.736 385.012 98.5359 385.012C128.685 385.012 151.843 372.341 167.135 352.244V380.204H237.043V321.221H223.061V81.3467Z" />
      <path d="M355.401 320.347C330.933 320.347 315.639 302.432 315.639 279.275C315.639 256.557 330.933 239.076 355.401 239.076C379.868 239.076 395.161 256.557 395.161 279.275C395.161 302.432 379.868 320.347 355.401 320.347ZM464.632 179.008H411.328V204.123C396.909 185.772 374.189 174.411 342.293 174.411C290.299 174.411 244.859 217.231 244.859 279.712C244.859 342.192 290.299 385.012 342.293 385.012C373.316 385.012 396.472 372.78 411.328 353.115V380.204H477.741V321.221H464.632V179.008Z" />
      <path d="M1513.67 295.932C1514.15 244.235 1605.59 157.479 1523 157.479H1460.28V378.705C1489.89 378.705 1502.75 378.705 1502.75 378.705C1554.95 185.621 1570.92 378.705 1570.92 378.705C1570.92 378.705 1643.76 378.705 1684.67 378.705C1707.64 343.528 1714.65 293.499 1700.64 264.965C1672.97 209.855 1556.55 213.592 1513.67 295.932Z" />
      <path d="M789.855 292.393C776.58 283.412 794.149 253.348 842.563 268.967C882.388 282.241 907.767 333.78 907.767 333.78C864.037 291.221 813.671 308.792 789.855 292.393ZM913.679 295.932C866.757 228.085 810.828 177.119 760.268 179.008H760.059L760.268 178.856H628.027V236.108H640.568L605.183 307.689L579.155 236.108H592.401V178.856H480.68V236.108H494.633L562.273 388.56L561.457 390.163C557.985 396.749 553.912 401.692 549.228 404.995C544.544 408.289 537.86 409.939 529.189 409.939H484.953V477.599H528.669C551.913 477.599 570.127 473.256 583.319 464.588C596.5 455.909 607.949 442.208 617.667 423.472L713.952 236.108L721.045 222.465C719.575 231.439 719.572 238.204 719.572 238.204C721.581 298.423 773.696 359.317 810.412 370.268C851.799 382.763 885.767 372.611 924.809 353.479C924.809 353.479 937.304 378.467 966.977 378.467V157.479H904.116C821.343 157.479 913.679 241.271 913.679 295.932Z" />
      <path d="M1072.55 326C1059.73 333.187 1041.17 307.335 1073.43 273.108C1100.08 245.129 1153.65 243.811 1153.65 243.811C1100.68 264.04 1095.67 312.417 1072.55 326ZM1167.37 197.98C1138.19 165.475 1033.77 175.553 984.469 194.873V264.432C1006.35 241.24 1032.51 224.833 1063.45 217.043C1095.19 209.055 1137.92 211.28 1153.76 223.403C1130.43 221.952 1098.05 223.673 1073.41 232.399C1019.43 251.519 973.309 293.815 976.929 344.868C978.739 374.5 1010.24 389.852 1042.83 380.925C1083.17 369.965 1119.33 335.856 1142.8 304.191C1147.41 297.961 1161.73 278.687 1164.35 271.789C1162.93 278.897 1157.21 292.973 1155.64 296.092C1136.55 334.124 1104.35 380.925 1140.57 380.925H1206.47V178.856C1206.47 178.856 1172.44 174.775 1167.37 197.98Z" />
    </svg>
  );
};

Icons.Contexto = function Contexto({ size }) {
  return (
    <svg
      width={size || 420}
      height={size || 420}
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="10" y="10" width="400" height="115" rx="30" fill="#B5E2DC" />
      <rect x="10" y="153" width="300" height="115" rx="30" fill="#F4DA92" />
      <rect x="10" y="295" width="200" height="115" rx="30" fill="#F7C0B5" />
    </svg>
  );
};

Icons.Conexo = function Conexo({ size }) {
  return (
    <svg
      width={size || 192}
      height={size || 192}
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.25 15.9029C2.25 8.36262 8.36262 2.25 15.9029 2.25H176.097C183.637 2.25 189.75 8.36262 189.75 15.9029V37.2925C189.75 39.8059 187.712 41.8434 185.199 41.8434H6.80097C4.28754 41.8434 2.25 39.8059 2.25 37.2925V15.9029Z"
        fill="#C2410C"
      />
      <path
        d="M2.25 55.9515C2.25 53.438 4.28754 51.4005 6.80097 51.4005H185.199C187.712 51.4005 189.75 53.438 189.75 55.9515V86.443C189.75 88.9564 187.712 90.9939 185.199 90.9939H6.80097C4.28754 90.9939 2.25 88.9564 2.25 86.443V55.9515Z"
        fill="#047857"
      />
      <path
        d="M2.25 105.557C2.25 103.044 4.28754 101.006 6.80097 101.006H185.199C187.712 101.006 189.75 103.044 189.75 105.557V136.049C189.75 138.562 187.712 140.6 185.199 140.6H6.80097C4.28754 140.6 2.25 138.562 2.25 136.049V105.557Z"
        fill="#0E7490"
      />
      <path
        d="M2.25 154.708C2.25 152.194 4.28754 150.157 6.80097 150.157H185.199C187.712 150.157 189.75 152.194 189.75 154.708V176.097C189.75 183.637 183.637 189.75 176.097 189.75H15.9029C8.36262 189.75 2.25 183.637 2.25 176.097V154.708Z"
        fill="#6D28D9"
      />
    </svg>
  );
};

Icons.Letroso = function Letroso({ size }) {
  return (
    <svg
      width={size || 420}
      height={size || 420}
      viewBox="0 0 420 420"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.375 10H110.625C118.564 10 125 16.4359 125 24.375V110.625C125 118.564 118.564 125 110.625 125H24.375C16.4359 125 10 118.564 10 110.625V24.375C10 16.4359 16.4359 10 24.375 10Z"
        fill="#22C55E"
      />
      <path
        d="M167.375 10H253.625C261.564 10 268 16.4359 268 24.375V110.625C268 118.564 261.564 125 253.625 125H167.375C159.436 125 153 118.564 153 110.625V24.375C153 16.4359 159.436 10 167.375 10Z"
        fill="#EAB308"
      />
      <path
        d="M309.375 10H395.625C403.564 10 410 16.4359 410 24.375V110.625C410 118.564 403.564 125 395.625 125H309.375C301.436 125 295 118.564 295 110.625V24.375C295 16.4359 301.436 10 309.375 10Z"
        fill="#3D3D66"
      />
      <path
        d="M24.375 153H110.625C118.564 153 125 159.436 125 167.375V253.625C125 261.564 118.564 268 110.625 268H24.375C16.4359 268 10 261.564 10 253.625V167.375C10 159.436 16.4359 153 24.375 153Z"
        fill="#3D3D66"
      />
      <path
        d="M167.121 153H353.516C384.711 153 410 178.744 410 210.5C410 242.256 384.711 268 353.516 268H167.121C159.322 268 153 261.564 153 253.625V167.375C153 159.436 159.322 153 167.121 153Z"
        fill="#22C55E"
      />
      <path
        d="M66.4706 295H353.529C384.717 295 410 320.744 410 352.5C410 384.256 384.717 410 353.529 410H66.4706C35.2827 410 10 384.256 10 352.5C10 320.744 35.2827 295 66.4706 295Z"
        fill="#22C55E"
      />
    </svg>
  );
};

Icons.Language = function Language() {
  return <span className="material-symbols-rounded">translate</span>;
};

export default Icons;
